import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/index',
      name: '卡详情',
      component: resolve => require(['../components/home'], resolve)

    },
    {
      path: '/orderDetail',
      name: '补登详情',
      component: resolve => require(['../components/orderDetail'], resolve)
    },
    {
      path: '/success',
      name: '提交成功',
      component: resolve => require(['../components/success'], resolve)
    },
    {
      path: '/order',
      name: '补登列表',
      component: resolve => require(['../components/order'], resolve)
    },
    {
      path: '/line',
      name: '开通线路',
      component: resolve => require(['../components/line'], resolve)
    },
    {
      path: '/mpHelp',
      name: '使用帮助',
      component: resolve => require(['../components/mpHelp'], resolve)
    },
    {
      path: '/help',
      name: '使用帮助',
      component: resolve => require(['../components/help'], resolve)
    },
    {
      path: '/station',
      name: '站点详情',
      component: resolve => require(['../components/station'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js